import { esusApi } from "@/services/api";

export type ResumeIndicatorB2Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB2Data {
	totalCitizensFinishedLinked: number = 0;
	totalCitizensFinished: number = 0;
	totalCitizens: number = 0;
}

export async function getResumeIndicatorB2({ uf, ibgeCode, ...params }: ResumeIndicatorB2Params) {
	const response = await esusApi.get<ResumeIndicatorB2Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b2/resume`,
		params
	);
	return response.data || new ResumeIndicatorB2Data();
}
